import { AxiosInstance } from "axios";

/**
 * The base API that should be extended.
 *
 * Handles setting up the Axios instance.
 */
export abstract class BaseApi {
  protected _instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    if (!instance) throw new Error("Axios instance is required");

    this._instance = instance;
  }
}
